import {
    Component,
    DoCheck,
    OnDestroy,
    OnInit,
    ViewChild,
    Input
} from '@angular/core';
import { Router } from '@angular/router';
import { EnterNewPasswordComponent } from '../../components/enterNewPassword/enterNewPassword.component';
import { EnterPhoneComponent } from '../../components/enterPhone/enterPhone.component';
import { EnterSMSCodeComponent } from '../../components/enterSMSCode/enterSMSCode.component';
import { AccountService } from '../../services/account.service';


@Component({
    selector: 'app-registration-by-phone',
    templateUrl: './registrationByPhone.component.html',
    styleUrls: ['./registrationByPhone.component.scss']
})
export class RegistrationByPhoneComponent implements OnInit, OnDestroy, DoCheck {

    constructor(
        private accountService: AccountService,
        private router: Router
    ) {
    }

    @ViewChild('enterPhoneComponent') enterPhoneComponent: EnterPhoneComponent;
    @ViewChild('enterSMSCodeComponent') enterSMSCodeComponent: EnterSMSCodeComponent;
    @ViewChild('enterNewPasswordComponent') enterNewPasswordComponent: EnterNewPasswordComponent;

    @Input() phoneValueWithRegion: string;
    public currentStep: number;

    ngOnInit(): void {
        this.currentStep = 1;
    }

    ngDoCheck(): void {
    }

    ngOnDestroy(): void {
    }

    public sendCode(event: Event): void {
        this.accountService.userRegistrationByPhone_SendCode(this.phoneValueWithRegion, this.enterPhoneComponent.captchaCode)
            .subscribe(response => {
                if (response.error == "CaptchaError") {
                    this.enterPhoneComponent.captchaError();
                } else {
                    this.enterSMSCodeComponent.startLifeTimeTimer();

                    // https://dev.azure.com/tekora/4I/_workitems/edit/5755/
                    // как бы ни был ответ сервера, все равно переходим на этап ввода кода
                    this.currentStep = 2;
                }
            });
    }

    public confirmCode(event: Event): void {
        this.accountService.userRegistrationByPhone_ConfirmCode(
            this.phoneValueWithRegion,
            this.enterSMSCodeComponent.confirmCodeValue
        )
            .subscribe(response => {
                if (!response.success) {
                    if (response.data.confirmCodeDeprecated) {
                        this.enterPhoneComponent.clear();
                        this.enterSMSCodeComponent.clear();
                        this.currentStep = 1;
                        return;
                    }

                    this.enterSMSCodeComponent.errorText = response.error;
                    return;
                }

                this.currentStep = 3;
            });
    }

    public setNewPassword(event: Event): void {
        this.accountService.userRegistrationByPhone_SetPassword(
            this.phoneValueWithRegion,
            this.enterNewPasswordComponent.passwordValue
        )
            .subscribe(response => {
                if (!response.success) {
                    this.enterNewPasswordComponent.errorText = response.error;
                    this.enterNewPasswordComponent.evaluatePasswordRules(response.data.ruleList);
                    return;
                }

                this.router.navigate(['./login'], { queryParamsHandling: 'merge' });
            });
    }
}
